import { useEffect, useState } from "react"

const useESIAFromSession = (defaultESIA: boolean) => {
  const [hasESIA, setHasESIA] = useState(defaultESIA)

  useEffect(() => {
    const storedValue = sessionStorage.getItem("hasESIA")
    if (storedValue === "true") {
      setHasESIA(true)
    } else if (storedValue === "false") {
      setHasESIA(false)
    }
  }, [])

  useEffect(() => {
    const handleStorageChange = () => {
      const storedValue = sessionStorage.getItem("hasESIA")
      if (storedValue === "true") {
        setHasESIA(true)
      } else if (storedValue === "false") {
        setHasESIA(false)
      }
    }
    window.addEventListener("session-storage-change", handleStorageChange)
    return () => {
      window.removeEventListener("session-storage-change", handleStorageChange)
    }
  }, [])

  return hasESIA
}

export default useESIAFromSession
